<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="qualities"
      :search="searchField"
      :loading="loading"
      :items-per-page="-1"
      hide-default-footer
      class="elevation-1 nowrap-headers"
    >
      <template #progress>
        <v-progress-linear color="red" indeterminate />
      </template>

      <template #item="{ item, index }">
        <tr
          :class="{ tableRowColorSelected: index == activeRow }"
          class="tableRowColor"
          @click="activeRow = index"
        >
          <td class="text-xs">
            {{ item.title }}
          </td>
          <td>
            <v-row row>
              <v-rating
                :model-value="item.rating"
                color="red"
                background-color="red-darken-4"
                readonly
              />
            </v-row>
          </td>
          <td class="text-xs">
            {{ item.value }}
          </td>
          <td class="text-xs">
            {{ item.description }}
          </td>
          <td class="justify-center">
            <v-row row>
              <v-icon
                class="mr-2 pointer"
                variant="text"
                color="grey-darken-2"
                @click="editQuality(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                class="mr-2 pointer"
                variant="text"
                color="grey-darken-2"
                @click="deleteQuality(item._id)"
              >
                mdi-delete
              </v-icon>
            </v-row>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogDelete" width="auto">
      <v-card>
        <v-card-title class="text-h6">
          <v-alert
            class="mb-0"
            :value="true"
            type="error"
            variant="tonal"
            border="bottom"
          >
            {{ $t("delete_alert") }}
          </v-alert>
        </v-card-title>

        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogDelete = false">
            {{ $t("close") }}
          </v-btn>
          <v-btn color="red" variant="outlined" @click="confirmDelete()">
            {{ $t("delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import getRequest from "../../api/getRequest";
import deleteRequest from "../../api/deleteRequest";

export default {
  data: () => ({
    loading: false,
    searchField: "",
    headers: [
      {
        title: "Title",
        sortable: false,
        key: "title",
      },
      {
        title: "Rating",
        sortable: false,
        key: "rating",
      },
      {
        title: "Value",
        sortable: false,
        key: "value",
      },
      {
        title: "Description",
        sortable: false,
        key: "description",
      },
      {
        title: "Actions",
        sortable: false,
      },
    ],
    qualities: [],
    activeRow: null,
    dialogDelete: false,
    qualityToDelete: null,
  }),
  mounted() {
    this.getLocale();
    this.getQualities();
  },
  methods: {
    getLocale() {
      this.headers[0].title = this.$t("quality.table.title");
      this.headers[1].title = this.$t("quality.table.rating");
      this.headers[2].title = this.$t("quality.table.value");
      this.headers[3].title = this.$t("quality.table.description");
      this.headers[4].title = this.$t("quality.table.actions");
    },
    getQualities() {
      this.loading = true;
      getRequest("/quality/")
        .then((response) => {
          this.qualities = response.qualities;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    editQuality(data) {
      this.$emit("edit", data);
    },
    deleteQuality(id) {
      this.qualityToDelete = id;
      this.dialogDelete = true;
    },
    confirmDelete() {
      this.loading = true;
      deleteRequest("/quality/", `id=${this.qualityToDelete}`)
        .then(() => {
          this.loading = false;
          this.qualityToDelete = null;
          this.dialogDelete = false;
          this.getQualities();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    search(value) {
      this.searchField = value;
    },
  },
};
</script>
